import { ContentMetadata } from '@/lib/model';
import { cn } from '@/lib/utils';
import React from 'react';

type Props = {
  mobileContentMetadata: ContentMetadata;
  desktopContentMetadata: ContentMetadata;
  className?: string;
  dataTestId?: string;
};

export function PlatformDescription({
  mobileContentMetadata,
  desktopContentMetadata,
  className,
  dataTestId,
}: Props) {
  if (
    mobileContentMetadata?.description === desktopContentMetadata?.description
  ) {
    return (
      <span className={className} data-testid={dataTestId}>
        {desktopContentMetadata?.description}
      </span>
    );
  }
  return (
    <>
      <span
        className={cn('inline lg:hidden', className)}
        data-testid={dataTestId}
      >
        {mobileContentMetadata?.description}
      </span>
      <span
        className={cn('hidden lg:inline', className)}
        data-testid={dataTestId}
      >
        {desktopContentMetadata?.description}
      </span>
    </>
  );
}
